import { IconComponent, useRouteRef } from '@backstage/core-plugin-api';
import { entityRouteRef } from '@backstage/plugin-catalog-react';
import { SidebarGroupLabel } from '../SidebarGroupLabel.tsx';
import { SidebarSubmenuItem } from '@backstage/core-components';
import { parseEntityRef } from '@backstage/catalog-model';
import { Team } from './Team';

interface TeamSubMenuProps {
  icon: IconComponent;
  teams: Team[];
  title: string;
}

export const TeamSubMenu = ({ icon, teams, title }: TeamSubMenuProps) => {
  const catalogEntityRoute = useRouteRef(entityRouteRef);

  return (
    <>
      <SidebarGroupLabel>{title}</SidebarGroupLabel>
      {teams.map((t: Team) => (
        <SidebarSubmenuItem
          title={t.name}
          to={catalogEntityRoute(parseEntityRef(t.entityRef))}
          icon={icon}
          key={t.name}
        />
      ))}
    </>
  );
};
